import React, { useState, useEffect, useRef } from 'react'
import Topbar from '../components/Layout/Topbar'
import { Sidebar } from '../components/Layout/Sidebar'
import Orders from '../components/Orders/Orders'
import { supabase, getUsersByRole } from '../supabase.config'
import ChoosePartner from '../components/Orders/ChoosePartner'
import { useDispatch, useSelector } from 'react-redux'
import { generateToken } from '../actions/shippingActions'
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';
// Firestore usage removed; Supabase used instead
import { pinCodeList } from '../data/pinCodeData'
import ForwardNoModal from '../components/Orders/ForwardNoModal'
import AutocompleteUser from '../components/ManageWarehouse/AutocompleteUser'
import { Button, Card, CardBody, CardFooter, Dialog } from '@material-tailwind/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ExportJsonCsv } from 'react-export-json-csv'
import { emitOrderNotification } from '../utils/notificationService'
import RecieverCopyContent from '../components/DigitalLR/RecieverCopyContent'

const ORDER_LIST_STATE_KEY = 'order-list-view-state'

const OrderList = () => {
  const getSavedListState = () => {
    try {
      const saved = sessionStorage.getItem(ORDER_LIST_STATE_KEY)
      return saved ? JSON.parse(saved) : {}
    } catch {
      return {}
    }
  }
  const savedListState = getSavedListState()
  const [orderList, setOrderList] = useState([])
  const [filteredOrderList, setFilteredOrderList] = useState([])
  const [branchInfo, setBranchInfo] = useState({})

  const { isAuthenticated, users, userProfile } = useSelector(
    (state) => state.user
  )
  const [delhiveryOrders, setDelhiveryOrders] = useState([])
  const [activeTab, setActiveTab] = useState(savedListState.activeTab || "all")
  const [hub, setHub] = useState("")
  const [branchList, setBranchList] = useState([])
  const [partnerModal, setPartnerModal] = useState(false)
  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange;
  const [selectedDatePreset, setSelectedDatePreset] = useState('')
  const [csvOrders, setCsvOrders] = useState([])
  const [actualdate, setActualdate] = useState("")
  const [partner, setPartner] = useState("")
  // const [, set] = useState(second)
  const [loadingOrder, setLoadingOrder] = useState("")
  const handleDateSelect = (ranges) => {
    console.log(ranges)
  }
  const [forwardNumber, setForwardNumber] = useState("")
  const [order, setOrder] = useState({})
  const [orderID, setOrderID] = useState("")
  const [orderActivity, setOrderActivity] = useState([])
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(Number.isInteger(savedListState.currentPage) ? savedListState.currentPage : 0);
  const [itemOffset, setItemOffset] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(Number.isInteger(savedListState.rowsPerPage) ? savedListState.rowsPerPage : 10);
  const [loadingMore, setLoadingMore] = useState(false);
  const [lastVisibleDoc, setLastVisibleDoc] = useState(null);
  const [forwardnoModal, setForwardnoModal] = useState(false)
  const [misModal, setMisModal] = useState(false)
  const [misClientList, setMisClientList] = useState([])
  const [selectedMisClient, setSelectedMisClient] = useState(null)
  const [misOrders, setMisOrders] = useState([])
  const [misLoading, setMisLoading] = useState(false)
  const [misDateRange, setMisDateRange] = useState({ start: '', end: '' })
  const [selectedOrderIds, setSelectedOrderIds] = useState([])
  const [bulkPrinting, setBulkPrinting] = useState(false)
  const { shippingToken } = useSelector(
    (state) => state.shippingToken
  );
  const actorUserId = userProfile?.id || userProfile?.uid || users || null
  const waybillRefs = useRef({})
  const dispatch = useDispatch()
  const normalizeStatus = (status) => String(status || '').trim().toLowerCase()
  const matchesActiveTab = (status, tabKey) => {
    const normalized = normalizeStatus(status)

    switch (tabKey) {
      case 'delivered':
        return normalized === 'delivered'
      case 'in-transit':
        return normalized === 'in-transit' || normalized === 'in transit'
      case 'pickedUp':
        return normalized === 'pickedup' || normalized === 'picked up'
      case 'new':
        return normalized === 'new'
      case 'out-for-delivery':
        return normalized === 'out for delivery'
      case 'all':
      default:
        return true
    }
  }
  const applyActiveTabFilter = (rows, tabKey = activeTab) => (
    (rows || []).filter((row) => matchesActiveTab(row?.orderStatus, tabKey))
  )
  const csvHeaders = [
    {
      key: 'lr',
      name: 'LR No',
    },
    {
      key: 'orderId',
      name: 'Order ID',
    },
    {
      key: 'forwardingNumber',
      name: 'Forwarding Number',
    },
    {
      key: 'bookingDate',
      name: 'Booking Date',
    },
    {
      key: 'deliveryDate',
      name: 'Delivery Date',
    },
    {
      key: 'invoiceno',
      name: 'Invoice Number',
    },
    {
      key: 'invoicevalue',
      name: 'Invoice Value',
    },
    {
      key: 'client',
      name: 'Client',
    },
    {
      key: 'consigneeName',
      name: 'Consignee Name',
    },
    {
      key: 'originPincode',
      name: 'Origin Pincode',
    },
    {
      key: 'consigneePincode',
      name: 'Consignee Pin Code',
    },
    {
      key: 'consigneecitystate',
      name: 'Consignee State',
    },
    {
      key: 'consigneecity',
      name: 'Consignee City',
    },
    {
      key: 'actualWeight',
      name: 'Actual Weight',
    },
    {
      key: 'chargableWeight',
      name: 'Chargable Weight',
    },
    {
      key: 'boxes',
      name: 'Boxes',
    },
    {
      key: 'status',
      name: 'Order Status',
    },
    {
      key: 'remark',
      name: 'Remark',
    },
  ]
  const handlePartnerModal = () => {
    setPartnerModal(!partnerModal)
  }
  const handleMisModal = () => {
    setMisModal(!misModal)
  }
  const handleForwardnoModal = () => {
    setForwardnoModal(!forwardnoModal)
    setPartnerModal(!partnerModal)
  }
  // Helpers for Supabase orders mapping
  const parseMaybeJSON = (v) => {
    if (!v) return null
    if (typeof v === 'object') return v
    try { return JSON.parse(v) } catch { return null }
  }
  const mapOrderRow = (row) => {
    const pkg = parseMaybeJSON(row.package_details) || {}
    const pickup = parseMaybeJSON(row.pickup_address) || {}
    const drop = parseMaybeJSON(row.delivery_address) || {}
    const dims = parseMaybeJSON(row.dimensions) || []
    const boxes = (dims || []).reduce((sum, d) => sum + Number(d.count || 0), 0)
    const chargeable = Math.ceil((dims || []).reduce((sum, d) => sum + (((d.length||0)*(d.width||0)*(d.height||0))/4500)*(d.count||0), 0))
    const createdAt = row.created_at ? new Date(row.created_at) : new Date()
    const deliveryActual = pkg.deliveryactualdate ? new Date(pkg.deliveryactualdate) : null
    return {
      id: row.id,
      orderId: row.order_id,
      orderNumber: row.order_number,
      lrno: row.tracking_number || row.order_number,
      lr: row.tracking_number || row.order_number,
      createdAt,
      bookingDate: createdAt.toDateString(),
      invoices: pkg.invoices || [],
      invoiceno: (pkg.invoices && pkg.invoices[0]?.ident) || undefined,
      invoicevalue: (pkg.invoices && pkg.invoices[0]?.n_value) || undefined,
      userName: pkg.userName,
      client: pkg.userName,
      deliveryactualdate: deliveryActual,
      expecteddate: deliveryActual ? deliveryActual.toLocaleDateString('en-GB') + ' ' + deliveryActual.toLocaleTimeString() : '',
      weight: row.weight,
      actualWeight: Number(row.weight || 0),
      totalChargeableWeight: chargeable,
      chargableWeight: chargeable,
      boxes,
      forwardingNumber: row.forwarding_number,
      forwardingPartner: row.forwarding_partner,
      dropoff_location: drop,
      pickup_location: pickup,
      orderStatus: row.status,
      pod: pkg.pod || '',
      undeliveredReason: pkg.undelivered_reason || '',
      undeliveredPod: pkg.undelivered_pod || '',
      uid: row.user_id,
      dimensions: dims,
    }
  }
  const lastSearchFetchRef = useRef('')
  const latestSearchRef = useRef('')
  const deleteOrder = async (id) => {
    const { error } = await supabase.from('orders').delete().eq('id', id)
    if (error) {
      toast.error('Failed to delete order: ' + error.message)
      return
    }
    setOrderList(prev => prev.filter(o => o.id !== id))
    setFilteredOrderList(prev => {
      const updated = prev.filter(o => o.id !== id)
      setCsvOrders(buildCsvOrders(updated))
      return updated
    })
    setSelectedOrderIds(prev => prev.filter(orderId => orderId !== id))
  }
  const getBoxes = (data) => {

    let totalBoxes = 0
    data?.dimensions?.map((d) => {
      totalBoxes = Number(totalBoxes) + Number(d?.count)

    })
    return totalBoxes
    console.log(totalBoxes)


  }
  const formatDateTime = (value) => {
    if (!value) return ''
    const dt = value instanceof Date ? value : new Date(value)
    if (Number.isNaN(dt.getTime())) return ''
    return dt.toLocaleDateString('en-GB') + ' ' + dt.toLocaleTimeString()
  }
  const getPresetDateRange = (preset) => {
    if (!preset) return [null, null]

    const now = new Date()
    const start = new Date(now)
    const end = new Date(now)

    if (preset === 'today') {
      start.setHours(0, 0, 0, 0)
      end.setHours(23, 59, 59, 999)
      return [start, end]
    }

    if (preset === 'yesterday') {
      start.setDate(start.getDate() - 1)
      end.setDate(end.getDate() - 1)
      start.setHours(0, 0, 0, 0)
      end.setHours(23, 59, 59, 999)
      return [start, end]
    }

    if (preset === 'lastWeek') {
      start.setDate(start.getDate() - 6)
      start.setHours(0, 0, 0, 0)
      end.setHours(23, 59, 59, 999)
      return [start, end]
    }

    if (preset === 'lastMonth') {
      start.setMonth(start.getMonth() - 1)
      start.setHours(0, 0, 0, 0)
      end.setHours(23, 59, 59, 999)
      return [start, end]
    }

    if (preset === 'lastYear') {
      start.setFullYear(start.getFullYear() - 1)
      start.setHours(0, 0, 0, 0)
      end.setHours(23, 59, 59, 999)
      return [start, end]
    }

    return [null, null]
  }
  const getActiveDateRange = () => {
    if (selectedDatePreset) {
      return getPresetDateRange(selectedDatePreset)
    }
    if (startDate && endDate) {
      const rangeStart = new Date(startDate)
      const rangeEnd = new Date(endDate)
      rangeStart.setHours(0, 0, 0, 0)
      rangeEnd.setHours(23, 59, 59, 999)
      return [rangeStart, rangeEnd]
    }
    return [null, null]
  }
  const mapOrderToCsv = (data) => {
    const pickup = data?.pickup_location || {}
    const drop = data?.dropoff_location || {}
    const latestActivity = Array.isArray(data?.orderActivity) && data.orderActivity.length > 0
      ? data.orderActivity[data.orderActivity.length - 1]
      : null
    return {
      lr: data?.lrno || data?.lr || '',
      orderId: data?.orderId || data?.orderNumber || '',
      forwardingNumber: data?.forwardingNumber || '',
      bookingDate: formatDateTime(data?.createdAt || data?.bookingDate),
      deliveryDate: data?.deliveryactualdate ? formatDateTime(data?.deliveryactualdate) : '',
      invoiceno: data?.invoiceno || '',
      invoicevalue: data?.invoicevalue || '',
      client: data?.userName || data?.client || '',
      consigneeName: drop?.companyName || drop?.name || '',
      originPincode: pickup?.pinCode || pickup?.pin_code || pickup?.zip || '',
      consigneePincode: drop?.zip || drop?.pinCode || drop?.pincode || '',
      consigneecitystate: drop?.region || drop?.state || '',
      consigneecity: drop?.city || '',
      actualWeight: data?.actualWeight || Number(data?.weight || 0) || '',
      chargableWeight: data?.totalChargeableWeight ? Math.ceil(data?.totalChargeableWeight) : (data?.chargableWeight || ''),
      boxes: data?.boxes || getBoxes(data),
      status: data?.orderStatus || data?.status || '',
      remark: latestActivity?.remark || data?.undeliveredReason || '',
    }
  }
  const buildCsvOrders = (orders) => orders.map(mapOrderToCsv)

  console.log(orderList)
  const fetchAdminOrders = async (loadMore = false) => {
    setLoadingOrder(true);
    setLoadingMore(loadMore);
    if (!loadMore) {
    setOrderList([]);
    setFilteredOrderList([]);
    setCsvOrders([]);
    }
    try {
    let q = supabase.from('orders').select('*').order('created_at', { ascending: false });

    const { data, error } = await q;
    if (error) {
      console.error('Failed to fetch orders', error);
      return;
    }
    const newOrders = applyActiveTabFilter((data || []).map(mapOrderRow));
    setOrderList(newOrders);
    setFilteredOrderList(newOrders);
    setCsvOrders(buildCsvOrders(newOrders));
    } catch (e) {
    console.error('fetchAdminOrders exception', e);
    } finally {
    setLoadingOrder(false);
    setLoadingMore(false);
    }
    };
    const fetchOrders = async () => {
      setOrderList([]);
      setFilteredOrderList([]);
      setLoadingOrder(true);
      try {
      if (!users) {
      console.warn('Supabase user id not ready');
      return;
      }
      let q = supabase.from('orders').select('*').eq('user_id', users).order('created_at', { ascending: false });
      
      const { data, error } = await q;
      if (error) {
        console.error('Failed to fetch user orders', error);
        return;
      }
      const rows = applyActiveTabFilter((data || []).map(mapOrderRow));
      setOrderList(rows);
      setFilteredOrderList(rows);
      setCsvOrders(buildCsvOrders(rows));
      } catch (e) {
      console.error('fetchOrders exception', e);
      } finally {
      setLoadingOrder(false);
      }
      };
  // const fetchBranch = async (city) => {
  //   const q = query(collection(db, "branchLogistics"))
  //   const querySnapshot = await getDocs(q);
  //   querySnapshot.forEach((doc) => {
  //     setBranchList((prev) => [...prev, {
  //       id: doc.id,
  //       ...doc.data()
  //     }])

  //   });
  // }

  const fetchOrder = async (id) => {
    const { data, error } = await supabase.from('orders').select('*').eq('id', id).single();
    if (error) {
    console.warn('Order not found', error);
    return;
    }
    const mapped = mapOrderRow(data);
    setOrder(mapped);
    const p = mapped.pickup_location || {};
    const pin = p.pinCode || p.pin_code;
    if (pin) {
    const found = pinCodeList.find(x => Number(x.Pin) === Number(pin));
    if (found) setHub(found.hub);
    }
    };
    
  const fetchOrderByLr = async (lrQuery) => {
    if (!lrQuery) return null
    try {
      let q = supabase.from('orders').select('*').order('created_at', { ascending: false });
      const [rangeStart, rangeEnd] = getActiveDateRange()
      if (rangeStart && rangeEnd) {
        q = q.gte('created_at', rangeStart.toISOString()).lte('created_at', rangeEnd.toISOString())
      }
      if (userProfile?.role !== 'admin' && users) {
        q = q.eq('user_id', users)
      }

      const { data, error } = await q.or(`tracking_number.eq.${lrQuery},order_number.eq.${lrQuery},order_id.eq.${lrQuery},id.eq.${lrQuery}`).limit(1);
      if (error) {
        console.error('Failed to fetch order by LR', error);
        return null;
      }
      if (!data || data.length === 0) return null
      const matched = applyActiveTabFilter(data.map(mapOrderRow))
      return matched[0] || null
    } catch (e) {
      console.error('fetchOrderByLr exception', e)
      return null
    }
  }

  // Unified search function that searches LR, order ID, client, consignee, and tracking
  const unifiedSearch = async (event) => {
    const rawQuery = event.target.value.trim();
    const query = rawQuery.toLowerCase();
    setSearchQuery(query);
    latestSearchRef.current = query;

    let updatedList;

    if (!query) {
      lastSearchFetchRef.current = '';
      updatedList = orderList; // Reset to full list when search is cleared
    } else {
      updatedList = orderList.filter((item) => {
        const lrMatch = item?.lrno?.toLowerCase().includes(query);
        const orderIdMatch = item?.orderId?.toLowerCase().includes(query);
        const orderNumberMatch = item?.orderNumber?.toLowerCase().includes(query);
        const dbIdMatch = item?.id?.toLowerCase().includes(query);
        const clientMatch = item?.userName?.toLowerCase().includes(query);
        const consigneeMatch = item?.dropoff_location?.companyName?.toLowerCase().includes(query);
        const consigneePersonMatch = item?.dropoff_location?.consignee?.toLowerCase().includes(query);
        const trackingMatch = item?.forwardingNumber?.toLowerCase().includes(query);
        
        return lrMatch || orderIdMatch || orderNumberMatch || dbIdMatch || clientMatch || consigneeMatch || consigneePersonMatch || trackingMatch;
      });
    }

    if (!query) {
      setFilteredOrderList(updatedList);
      setCsvOrders(buildCsvOrders(updatedList));
    } else if (updatedList.length > 0) {
      setFilteredOrderList(updatedList);
      setCsvOrders(buildCsvOrders(updatedList));
      lastSearchFetchRef.current = '';
    } else {
      setFilteredOrderList([]);
      setCsvOrders([]);
      if (rawQuery && lastSearchFetchRef.current !== rawQuery) {
        lastSearchFetchRef.current = rawQuery;
        const fetched = await fetchOrderByLr(rawQuery);
        if (latestSearchRef.current !== query) return;
        if (fetched) {
          setFilteredOrderList([fetched]);
          setCsvOrders(buildCsvOrders([fetched]));
        }
      }
    }

    // ✅ Reset pagination so filtered results appear on the first page
    setCurrentPage(0);
    setItemOffset(0);
  };


  console.log(orderList)

  const handleDeliveryShipping = async () => {
    try {
      const date = new Date()
      // Ensure token and fresh order
      if (!shippingToken?.jwt) dispatch(generateToken())
      await fetchOrder(orderID)

      if (!orderID || Object.keys(order || {}).length === 0) {
        toast.error('Order not loaded')
        return
      }

      const payload = {
        ident: '',
        pickup_location: order?.pickup_location?.pickupName?.companyName || order?.pickup_location?.companyName || order?.userName || '',
        dropoff_location: order?.dropoff_location,
        return_address: {
          address: order?.pickup_location?.address,
          zip: order?.pickup_location?.pinCode,
          name: order?.pickup_location?.pinCode,
          city: order?.pickup_location?.city,
          region: order?.pickup_location?.state,
          phone: order?.pickup_location?.personName
        },
        d_mode: 'Prepaid',
        amount: 0.0,
        rov_insurance: true,
        invoices: order?.invoices,
        weight: Number(order?.weight || 0),
        suborders: order?.suborders,
        dimensions: order?.dimensions,
        consignee_gst_tin: order?.consignee_gst_tin,
        seller_gst_tin: order?.seller_gst_tin,
        cb: {}
      }

      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://btob.api.delhivery.com/v3/manifest',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + (shippingToken?.jwt || '')
        },
        data: JSON.stringify(payload)
      }

      const response = await axios(config)
      setPartnerModal(false)
      toast.success('Order Shipped Successfully')

      // Update order in Supabase
      const { data: current, error: fetchErr } = await supabase.from('orders').select('*').eq('id', orderID).single()
      if (fetchErr) return
      const pkg = parseMaybeJSON(current?.package_details) || {}
      const updatedPkg = {
        ...pkg,
        job_id: response?.data?.job_id,
        orderActivity: [...(pkg.orderActivity || []), { status: 'Picked Up', remark: 'Order has been Pickedup', location: 'GRC Bhiwandi', time: date }]
      }
      await supabase.from('orders').update({ status: 'pickedUp', package_details: updatedPkg }).eq('id', orderID)
      await emitOrderNotification({
        actorUserId,
        order: { ...current, status: 'pickedUp', package_details: updatedPkg },
        eventType: 'order_picked_up',
        title: 'Order picked up',
        message: `Order ${current?.tracking_number || current?.order_number || current?.order_id || ''} was assigned for forwarding pickup.`,
        metadata: { partner: 'Delivery Partner' },
      })
    } catch (err) {
      console.error('handleDeliveryShipping error', err)
      toast.error('Order has an error while shipping')
    }
  }


  const fetchByDate = async () => {
    const [rangeStart, rangeEnd] = getActiveDateRange()
    if (!rangeStart || !rangeEnd) return;
    setLoadingOrder(true);
    setOrderList([]);
    setFilteredOrderList([]);
    setCsvOrders([]);
    try {
    let q = supabase
    .from('orders')
    .select('*')
    .gte('created_at', rangeStart.toISOString())
    .lte('created_at', rangeEnd.toISOString())
    .order('created_at', { ascending: false });
    if (userProfile?.role !== 'admin' && users) {
      q = q.eq('user_id', users)
    }
    const { data, error } = await q;
    if (error) {
    console.error('Failed to fetch by date', error);
    return;
    }
    const rows = applyActiveTabFilter((data || []).map(mapOrderRow));
    setOrderList(rows);
    setFilteredOrderList(rows);
    setCsvOrders(buildCsvOrders(rows));
    setCurrentPage(0)
    setItemOffset(0)
    } finally {
      setLoadingOrder(false)
    }
    };
  const clearDate = () => {
    setSelectedDatePreset('')
    setDateRange([null, null])
    if (userProfile?.role === "admin") {
      fetchAdminOrders()
    }
    else {
      fetchOrders()
    }
  }
  const handleOwnShipping = async () => {
    const date = new Date()
    fetchOrder(orderID)
    console.log(order)
    if (Object.keys(order).length !== 0) {
      const { data: current, error: fetchErr } = await supabase.from('orders').select('*').eq('id', orderID).single()
      if (fetchErr) return
      const pkg = parseMaybeJSON(current?.package_details) || {}
      const updatedPkg = {
        ...pkg,
        orderActivity: [...(pkg.orderActivity || []), {
          status: "Picked Up", remark: "Order has been Pickedup", location: "GRC Bhiwandi", time: date
        }]
      }
      const { error } = await supabase.from('orders').update({ status: 'pickedUp', forwarding_number: current?.tracking_number, package_details: updatedPkg }).eq('id', orderID)
      if (!error) {
        await emitOrderNotification({
          actorUserId,
          order: { ...current, status: 'pickedUp', forwarding_number: current?.tracking_number, package_details: updatedPkg },
          eventType: 'order_picked_up',
          title: 'Order picked up',
          message: `Order ${current?.tracking_number || current?.order_number || current?.order_id || ''} was marked picked up.`,
          metadata: { partner: 'GRC' },
        })
        handlePartnerModal()
      }
    }

  }



  const orderChangeStatus = async () => { return; };
  const fetchMisClients = async () => {
    const { data, error } = await getUsersByRole('client', 'logistics')
    if (error) {
      console.error('Failed to fetch MIS customers', error)
      return
    }
    const clients = (data || []).map((u) => ({
      id: u.id,
      name: u.company_name || u.name || u.email,
      companyName: u.company_name,
      email: u.email
    }))
    setMisClientList(clients)
  }
  const fetchMisOrdersForClient = async (clientId, selectedRange = misDateRange) => {
    if (!clientId) return
    setMisLoading(true)
    setMisOrders([])
    try {
      let q = supabase.from('orders').select('*').eq('user_id', clientId).order('created_at', { ascending: false })
      if (selectedRange?.start && selectedRange?.end) {
        const rangeStart = new Date(`${selectedRange.start}T00:00:00`)
        const rangeEnd = new Date(`${selectedRange.end}T23:59:59.999`)
        q = q.gte('created_at', rangeStart.toISOString()).lte('created_at', rangeEnd.toISOString())
      }
      const { data, error } = await q
      if (error) {
        console.error('Failed to fetch MIS orders', error)
        return
      }
      const rows = applyActiveTabFilter((data || []).map(mapOrderRow))
      setMisOrders(buildCsvOrders(rows))
    } catch (e) {
      console.error('fetchMisOrdersForClient exception', e)
    } finally {
      setMisLoading(false)
    }
  }
  const handleMisClientChange = (client) => {
    setSelectedMisClient(client)
    if (client?.id) {
      fetchMisOrdersForClient(client.id, misDateRange)
    } else {
      setMisOrders([])
    }
  }
  const handleMisDateRangeChange = (field, value) => {
    const nextRange = { ...misDateRange, [field]: value }
    setMisDateRange(nextRange)
    if (selectedMisClient?.id && nextRange.start && nextRange.end) {
      fetchMisOrdersForClient(selectedMisClient.id, nextRange)
    }
    if (selectedMisClient?.id && !nextRange.start && !nextRange.end) {
      fetchMisOrdersForClient(selectedMisClient.id, nextRange)
    }
  }
  const toggleOrderSelection = (orderId) => {
    if (!orderId) return
    setSelectedOrderIds(prev =>
      prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]
    )
  }
  const getSelectedOrders = () => orderList.filter((order) => selectedOrderIds.includes(order.id))
  const toggleSelectAllVisible = (visibleIds, checked) => {
    setSelectedOrderIds(prev => {
      const visibleSet = new Set(visibleIds || [])
      if (checked) {
        const merged = new Set(prev)
        visibleSet.forEach(id => merged.add(id))
        return Array.from(merged)
      }
      return prev.filter(id => !visibleSet.has(id))
    })
  }
  const clearSelectedOrders = () => {
    setSelectedOrderIds([])
  }
  const bulkDeleteSelected = async () => {
    if (!selectedOrderIds.length) return
    if (!window.confirm(`Delete ${selectedOrderIds.length} selected order(s)?`)) return
    const { error } = await supabase.from('orders').delete().in('id', selectedOrderIds)
    if (error) {
      toast.error('Failed to delete orders: ' + error.message)
      return
    }
    const removeSet = new Set(selectedOrderIds)
    setOrderList(prev => prev.filter(o => !removeSet.has(o.id)))
    setFilteredOrderList(prev => {
      const updated = prev.filter(o => !removeSet.has(o.id))
      setCsvOrders(buildCsvOrders(updated))
      return updated
    })
    setSelectedOrderIds([])
  }
  const handleBulkShip = () => {
    if (!selectedOrderIds.length) {
      toast.error('Please select at least one order to ship')
      return
    }
    const invalidOrders = getSelectedOrders().filter((order) => String(order?.orderStatus || '').toLowerCase() !== 'new')
    if (invalidOrders.length) {
      toast.error('Only new orders can be shipped in bulk')
      return
    }
    setOrderID(selectedOrderIds[0])
    setPartnerModal(true)
  }
  const openBulkDocuments = (documentType) => {
    if (!selectedOrderIds.length) {
      toast.error(`Please select at least one order to download ${documentType}`)
      return
    }
    const targetOrders = getSelectedOrders()
    const routeSegment = documentType === 'waybill' ? 'waybill' : 'shippinglabel'
    let openedCount = 0

    targetOrders.forEach((order) => {
      const nextWindow = window.open(`/orderDetails/${routeSegment}/${order.id}`, '_blank', 'noopener,noreferrer')
      if (nextWindow) openedCount += 1
    })

    if (!openedCount) {
      toast.error(`Please allow popups to download ${documentType}`)
      return
    }

    toast.success(`Opened ${openedCount} ${documentType}${openedCount === 1 ? '' : 's'}`)
  }
  const handleBulkShipSuccess = (processedOrderIds = []) => {
    const processedSet = new Set(processedOrderIds)
    setSelectedOrderIds([])
    setPartner('')
    setForwardNumber('')
    setOrderID('')
    setOrderList((prev) => prev.map((order) => (
      processedSet.has(order.id)
        ? {
            ...order,
            orderStatus: 'pickedUp',
            forwardingPartner: partner || order.forwardingPartner,
            forwardingNumber: String(partner || '').toUpperCase() === 'GRC'
              ? (order.lrno || order.orderNumber || order.forwardingNumber || '')
              : (forwardNumber || order.forwardingNumber || ''),
          }
        : order
    )))
    setFilteredOrderList((prev) => prev.map((order) => (
      processedSet.has(order.id)
        ? {
            ...order,
            orderStatus: 'pickedUp',
            forwardingPartner: partner || order.forwardingPartner,
            forwardingNumber: String(partner || '').toUpperCase() === 'GRC'
              ? (order.lrno || order.orderNumber || order.forwardingNumber || '')
              : (forwardNumber || order.forwardingNumber || ''),
          }
        : order
    )))
    refreshOrders()
  }
  const bulkPrintSelected = async () => {
    if (!selectedOrderIds.length) {
      toast.error('Please select at least one order to print')
      return
    }

    setBulkPrinting(true)
    try {
      const selectedOrders = orderList.filter((order) => selectedOrderIds.includes(order.id))
      const waybillContents = []

      selectedOrders.forEach((order) => {
        const wrapperRef = waybillRefs.current[order.id]
        if (wrapperRef) {
          waybillContents.push(wrapperRef.cloneNode(true).outerHTML)
        }
      })

      if (!waybillContents.length) {
        toast.error('No waybills found to print')
        return
      }

      const printWindow = window.open('', '_blank', 'width=1200,height=800')
      if (!printWindow) {
        toast.error('Please allow popups to print waybills')
        return
      }

      const linkTags = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
        .map((link) => `<link rel="stylesheet" href="${link.href}">`)
        .join('\n')

      const styleTags = Array.from(document.querySelectorAll('style'))
        .map((style) => `<style>${style.innerHTML}</style>`)
        .join('\n')

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>Bulk Waybills - ${selectedOrders.length} waybill(s)</title>
            ${linkTags}
            ${styleTags}
            <style>
              @media print {
                @page {
                  margin: 0;
                  size: A4 landscape;
                }
                body {
                  margin: 0;
                  padding: 0;
                }
                .waybill-page {
                  page-break-after: always;
                  page-break-inside: avoid;
                }
                .waybill-page:last-child {
                  page-break-after: auto;
                }
                * {
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                }
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
                background: white;
              }
              .waybill-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                width: 100%;
              }
              .waybill-page {
                margin-bottom: 20px;
              }
            </style>
          </head>
          <body>
            <div class="waybill-container">
              ${waybillContents.map((content) => `<div class="waybill-page">${content}</div>`).join('')}
            </div>
          </body>
        </html>
      `)
      printWindow.document.close()

      await new Promise((resolve) => {
        const checkLoad = () => {
          if (printWindow.document.readyState === 'complete') {
            setTimeout(() => {
              printWindow.print()
              resolve()
            }, 2000)
          } else {
            setTimeout(checkLoad, 100)
          }
        }
        checkLoad()
        setTimeout(() => {
          if (printWindow && !printWindow.closed) {
            printWindow.print()
          }
          resolve()
        }, 10000)
      })

      toast.success(`Prepared ${selectedOrders.length} waybill(s) for printing`)
      setSelectedOrderIds([])
    } catch (error) {
      console.error('Error printing waybills:', error)
      toast.error('Error printing waybills: ' + (error.message || 'Unknown error'))
    } finally {
      setBulkPrinting(false)
    }
  }
  const refreshOrders = () => {
    const [rangeStart, rangeEnd] = getActiveDateRange()
    if (rangeStart && rangeEnd) {
      fetchByDate()
      return
    }
    if (userProfile?.role === 'admin') {
      fetchAdminOrders(false)
      return
    }
    if (users) {
      fetchOrders()
    }
  }

  useEffect(() => {
    if (!userProfile?.role) return;
    const [rangeStart, rangeEnd] = getActiveDateRange()
    if (rangeStart && rangeEnd) {
      fetchByDate()
    } else if (userProfile.role === 'admin') {
      fetchAdminOrders(false);
    } else if (users) {
      fetchOrders();
    }
    // fetchBranch() can remain placeholder
    }, [activeTab, userProfile?.role, users]);
  useEffect(() => {
    if (userProfile?.role === 'admin') {
      fetchMisClients();
    }
  }, [userProfile?.role]);
  useEffect(() => {
    try {
      sessionStorage.setItem(
        ORDER_LIST_STATE_KEY,
        JSON.stringify({
          activeTab,
          currentPage,
          rowsPerPage,
        })
      )
    } catch {
      // Ignore storage failures and continue with in-memory state.
    }
  }, [activeTab, currentPage, rowsPerPage])
  useEffect(() => {
    if (selectedDatePreset) {
      fetchByDate()
      return
    }

    if (!startDate && !endDate) {
      if (userProfile?.role === 'admin') {
        fetchAdminOrders(false)
      } else if (users) {
        fetchOrders()
      }
    }
  }, [selectedDatePreset])
  useEffect(() => {
    // const intervalCall = setInterval(() => {
    //   handleDeliveryStatus();
    // }, 3000);
    // return () => {
    //   // clean up
    //   clearInterval(intervalCall);
    // };


  }, [])



  return (
    <>
      <div className='bg-gray-100 flex ' >
        <Toaster />
        <Dialog
          size="sm"
          open={misModal}
          handler={handleMisModal}
          className="bg-transparent shadow-none"
        >
          <Card className="lg:mx-auto relative w-full">
            <div className='px-6 pt-4 flex items-center justify-between'>
              <h3 className='text-[1.4rem] font-[GilroyBold]'>Download MIS</h3>
              <div onClick={handleMisModal} className="cursor-pointer w-[40px] h-[40px]">
                <XMarkIcon className='w-[30px]' />
              </div>
            </div>
            <CardBody className="max-h-[320px] overflow-y-auto">
              <div className='flex flex-col gap-3'>
                <label className='text-sm text-gray-700'>Select customer</label>
                <AutocompleteUser
                  selected={selectedMisClient}
                  setSelected={handleMisClientChange}
                  data={misClientList}
                  placeholder="Search customer"
                />
                <div className='grid grid-cols-1 gap-3 sm:grid-cols-2'>
                  <div className='flex flex-col gap-2'>
                    <label className='text-sm text-gray-700'>Start date</label>
                    <input
                      type='date'
                      value={misDateRange.start}
                      onChange={(event) => handleMisDateRangeChange('start', event.target.value)}
                      className='w-full rounded-[20px] border border-slate-200 bg-white px-4 py-3 text-[15px] text-slate-900 shadow-[0_8px_22px_rgba(15,23,42,0.04)] outline-none transition-all focus:border-[#fdba74] focus:shadow-[0_12px_24px_rgba(249,115,22,0.08)]'
                    />
                  </div>
                  <div className='flex flex-col gap-2'>
                    <label className='text-sm text-gray-700'>End date</label>
                    <input
                      type='date'
                      value={misDateRange.end}
                      onChange={(event) => handleMisDateRangeChange('end', event.target.value)}
                      className='w-full rounded-[20px] border border-slate-200 bg-white px-4 py-3 text-[15px] text-slate-900 shadow-[0_8px_22px_rgba(15,23,42,0.04)] outline-none transition-all focus:border-[#fdba74] focus:shadow-[0_12px_24px_rgba(249,115,22,0.08)]'
                    />
                  </div>
                </div>
                {misLoading ? (
                  <p className='text-sm text-gray-500'>Loading orders...</p>
                ) : selectedMisClient ? (
                  <p className='text-xs text-gray-500'>
                    {misOrders.length} order{misOrders.length === 1 ? '' : 's'} found
                  </p>
                ) : null}
              </div>
            </CardBody>
            <CardFooter className="border-t-1 border-gray-300 bg-gray-200 flex items-center justify-end gap-3">
              <Button onClick={handleMisModal} className='bg-gray-600'>Cancel</Button>
              {selectedMisClient && !misLoading && misOrders.length > 0 ? (
                <ExportJsonCsv
                  headers={csvHeaders}
                  items={misOrders}
                  fileTitle={`MIS_${(selectedMisClient?.name || 'Customer').replace(/[^a-zA-Z0-9]/g, '_')}`}
                  className="bg-[#FFB200] hover:bg-[#e6a000] text-black px-4 py-2 rounded-md text-sm font-medium"
                >
                  Download MIS
                </ExportJsonCsv>
              ) : (
                <Button disabled className='bg-gray-400'>
                  Download MIS
                </Button>
              )}
            </CardFooter>
          </Card>
        </Dialog>
        <ForwardNoModal orderActivity={orderActivity} handleForwardnoModal={handleForwardnoModal} forwardnoModal={forwardnoModal} setForwardnoModal={setForwardnoModal} orderID={orderID} />
        <ChoosePartner orderID={orderID} orderIDs={selectedOrderIds} onShipSuccess={handleBulkShipSuccess} orderActivity={orderActivity} partner={partner} setForwardNumber={setForwardNumber} forwardNumber={forwardNumber} setPartner={setPartner} handleForwardnoModal={handleForwardnoModal} branchList={branchList} branchInfo={branchInfo} setBranchInfo={setBranchInfo} handleOwnShipping={handleOwnShipping} handleDeliveryShipping={handleDeliveryShipping} partnerModal={partnerModal} setPartnerModal={setPartnerModal} handlePartnerModal={handlePartnerModal} />
        <Sidebar />

        <div className='h-[100vh] overflow-y-scroll flex flex-1 flex-col' >
          <Topbar />
          <Orders fetchAdminOrders={fetchAdminOrders} loadingMore={loadingMore} refreshOrders={refreshOrders} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} setFilteredOrderList={setFilteredOrderList} unifiedSearch={unifiedSearch} setItemOffset={setItemOffset} setCurrentPage={setCurrentPage} currentPage={currentPage} searchQuery={searchQuery} csvOrders={csvOrders} csvHeaders={csvHeaders} isAdmin={userProfile?.role === 'admin'} onOpenMisModal={handleMisModal} selectedOrderIds={selectedOrderIds} onClearSelection={clearSelectedOrders} onBulkShip={handleBulkShip} onBulkWaybillDownload={() => openBulkDocuments('waybill')} onBulkBarcodeDownload={() => openBulkDocuments('barcode')} onBulkDelete={bulkDeleteSelected} onBulkPrint={bulkPrintSelected} bulkPrinting={bulkPrinting} loadingOrder={loadingOrder} clearDate={clearDate} fetchByDate={fetchByDate} dateRange={dateRange} setDateRange={setDateRange} startDate={startDate} endDate={endDate} selectedDatePreset={selectedDatePreset} setSelectedDatePreset={setSelectedDatePreset} deleteOrder={deleteOrder} filteredOrderList={filteredOrderList} setOrderID={setOrderID} handlePartnerModal={handlePartnerModal} activeTab={activeTab} setActiveTab={setActiveTab} orderList={orderList} toggleOrderSelection={toggleOrderSelection} toggleSelectAllVisible={toggleSelectAllVisible} />
          <div style={{ position: 'absolute', left: '-9999px', top: '-9999px', visibility: 'hidden', width: '1200px' }}>
            {orderList.map((order) => (
              <div
                key={order.id}
                ref={(el) => {
                  if (el) {
                    waybillRefs.current[order.id] = el
                  }
                }}
              >
                <RecieverCopyContent id={order.lrno} orderDetail={order} documentType="Waybill" />
              </div>
            ))}
          </div>
        </div>
      </div>

    </>
  )
}

export default OrderList
